module.exports = __webpack_public_path__ + "img/case.7f983b27.svg";